import React from 'react';
import cx from 'classnames';
import Table from 'react-bootstrap/Table';
import styles from '../../common/TransactionHistory/TransactionHistory.module.scss';
import DownloadIcon from '../icons/DownloadIcon';
import { download } from '../../common/DownloadFileController/downloadFile';

function TemplateInfoTable({ responsive, tableHeadings, tableBody, topMargin, page = 1, perPage = 1 }) {
  const tableClassName = cx(
    `basic-table ${styles.table}`,
    responsive && `table-responsive-${styles.table}`
  );

  const tableBodyClass = cx(styles.tableBody);
  const tableColumnClassName = cx(styles.tableColumn, styles.textAlignLeft);
  const tableHeaderClass = cx(styles.tableHeader, topMargin && styles.topMargin);

  const handleDownloadClick =async (file) => {
    await download({fileUrl:file.file_download_url,fileName:file.name}) 
  }
  if (!tableHeadings) return null;

  return (
    <>
      <Table striped bordered className={tableClassName}>
        <thead className={tableHeaderClass}>
          <tr className={styles.borderNone}>
            <th className={styles.tableIndex}>#</th>
            {tableHeadings}
          </tr>
        </thead>
        <tbody className={tableBodyClass}>
          {tableBody.map((a, i) => {
            return (
              <tr key={a.id}>
                <td className={styles.tableIndex}>{(perPage * (page - 1)) + (i + 1)}</td>
                <td className={tableColumnClassName}>{a.name}</td>
                {a.date !== undefined && <td className={tableColumnClassName}>{a.date}</td>}
                {a.email !== undefined && <td className={tableColumnClassName}>{a.email}</td>}
                {a.resolution !== undefined && (
                  <td className={tableColumnClassName}>{a.resolution}</td>
                )}
                {a.format !== undefined && <td className={tableColumnClassName}>{a.format}</td>}
                {a.texture !== undefined && <td className={tableColumnClassName}>{a.texture || "-----------------------------"}</td>}
                {a.file_download_url !== undefined && (
                  <td className={tableColumnClassName}>
                    {a.file_download_url && <DownloadIcon className={styles.downloadIcon} onClick={() => handleDownloadClick(a)}/>}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
}

export default TemplateInfoTable;
